module.exports = __webpack_public_path__ + "img/6C5DC3_352D66_5C4CAB_544CA5-256px.52b3c4bf.png";